import createEnum from 'scripts/lib/create_enum';

const FeatureNotificationTypes = createEnum();
export default FeatureNotificationTypes;
